import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
import { getGamePath } from './../../Utils/pathUtils.js';

import * as fJS from './../cjsRoot/fJS';
import { jsColor } from './../cjsRoot/jsColor';
import { cjsItem } from './../cjsRoot/cjsBase';
import STORE from '@/store';

export class cjsDraw extends cjsItem {
  _dim;
  _drawing;
  _lastPoint;
  _trace;
  _point;
  _thrown;
  _mask;

  constructor(obj) {
    super(obj);
    this._trace = [];
    this._thrown = false;
    this._mask = false;
    this._drawing = new createjs.Shape();
    this._drawing.name = this.idGroup + '_' + this.id;
  }

  create() {
    super.create();
    this._dim = {
      width:
        typeof this.otherProperty.maze != 'undefined' &&
        typeof this.otherProperty.maze != null &&
        typeof this.otherProperty.maze.canvas != 'undefined' &&
        this.otherProperty.maze.canvas != null &&
        fJS.isNumeric(this.otherProperty.maze.canvas.width) &&
        this.otherProperty.maze.canvas.width > 0 &&
        this.otherProperty.maze.canvas.width <= this._stage.width
          ? this.otherProperty.maze.canvas.width
          : this._stage.width,
      height:
        typeof this.otherProperty.maze != 'undefined' &&
        typeof this.otherProperty.maze != null &&
        typeof this.otherProperty.maze.canvas != 'undefined' &&
        this.otherProperty.maze.canvas != null &&
        fJS.isNumeric(this.otherProperty.maze.canvas.height) &&
        this.otherProperty.maze.canvas.height > 0 &&
        this.otherProperty.maze.canvas.height <= this._stage.height
          ? this.otherProperty.maze.canvas.height
          : this._stage.height,
    };

    if (!this.block) {
      this._lastPoint = new createjs.Point();

      this._point = {
        color: false,
        start: false,
        stop: false,
        size: -1,
      };

      if (
        typeof this.otherProperty.maze != 'undefined' &&
        typeof this.otherProperty.maze != null &&
        typeof this.otherProperty.maze.mask != 'undefined' &&
        this.otherProperty.maze.mask != null
      ) {
        let multibookType = this._stage._mixins.multibookType;
        let imgPath = getGamePath(this.otherProperty.maze.mask.src);
        try {
          this.otherProperty.maze.mask.src = require(`__staticDir/${multibookType}/${imgPath}`);
        } catch (e) {
          console.log(e);
          console.log('Jeżeli to klon, to OK ;)');
        }
        this._addMask();
      }
    }
  }

  get drawing() {
    return this._drawing;
  }

  set drawing(v) {
    this._drawing = v;
  }

  get mousedown() {
    return this._mousedown;
  }

  set mousedown(v) {
    this._mousedown = v;
  }

  get lastPoint() {
    return this._lastPoint;
  }

  set lastPoint(v) {
    this._lastPoint = v;
  }

  get trace() {
    return this._trace;
  }

  set trace(v) {
    this._trace = v;
  }

  get thrown() {
    return this._thrown;
  }

  set thrown(v) {
    this._thrown = v;
  }

  get drawCorrect() {
    return this._drawCorrect;
  }

  set drawCorrect(v) {
    this._drawCorrect = v;
  }

  get point() {
    return this._point;
  }

  get mask() {
    return this._mask;
  }
}

cjsDraw.redraw = function (stage) {
  stage.drawing.updateCache();
  let shape = stage.drawing.children[0];

  for (let gr in stage.groups) {
    for (let id in stage.groups[gr].items) {
      let item = stage.groups[gr].items[id];
      if (item.trace.length == 0) {
        continue;
      }
      for (let i = 0; i < item.trace.length; i++) {
        if (i + 1 >= item.trace.length) break;
        shape.graphics.ss(item.point.size, 'round').s(item.point.color);
        shape.graphics.mt(item.trace[i].x, item.trace[i].y);
        shape.graphics.lt(item.trace[i + 1].x, item.trace[i + 1].y);
        stage.drawing.updateCache('source-over');
        shape.graphics.clear();
      }
      item.lastPoint = item.trace[item.trace.length - 1];
    }
  }
};

cjsDraw.resetGameAction = function (stage) {
  console.log('cjsTraceDraw RESET');
  stage._stage.off('pressmove', stage.listener.pm);
};

cjsDraw.afterLoadSamples = function (stage) {
  console.log('cjsTraceDraw afterLoadSamples');

  cjsItem.afterLoadSamples(stage);

  stage.drawing = new createjs.Container();
  stage.drawing.name = 'drawing';
  stage.drawing.hitArea = new createjs.Shape(new createjs.Graphics().f('#000').dr(0, 0, stage.width, stage.height));
  stage.drawing.x -= stage.offset.x;
  stage.drawing.y -= stage.offset.y;
};
